module.exports = __webpack_public_path__ + "static/img/txt-002-kanjita.cbe0066.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/txt-002-kanjita.svg
// module id = GDAL
// module chunks = 1